export default {
  getMediationList (state, getters, rootState, rootGetters) {
    const mediation = rootGetters['monetization/currentMediation']
    return state.mediationList[mediation]
  }
}
